import styled from 'styled-components';

export const Accordion = styled.div`
  padding-top: ${({ theme }) => theme.spacing.S12};
  border-bottom: 1px solid #d9d9d9;
`;
export const Header = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  cursor: pointer;
`;
export const Body = styled.div`
  padding: ${({ theme }) => theme.spacing.M16} 0;
`;
